import React from 'react';

// 카드 스타일
export const cardStyle: React.CSSProperties = {
  borderRadius: 8,
  overflow: 'hidden',
  transition: 'transform 0.3s, box-shadow 0.3s',
};

// 카드 호버 스타일 (별도 적용)
export const cardHoverStyle: React.CSSProperties = {
  transform: 'translateY(-5px)',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
};

// 카드 헤더 스타일
export const cardHeaderStyle = (color: string): React.CSSProperties => ({
  backgroundColor: color,
  padding: 16,
  display: 'flex',
  alignItems: 'center',
  color: 'white',
});

// 아바타 스타일
export const avatarStyle = (color: string): React.CSSProperties => ({
  backgroundColor: 'white',
  color,
  marginRight: 16,
});

// 프로필 이미지 컨테이너 스타일
export const profileImageContainerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: 16,
};

// 프로필 이미지 스타일
export const profileImageStyle: React.CSSProperties = {
  width: 100,
  height: 100,
  border: '3px solid var(--Color-fill-brand-color, #FF6F0F)',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
};

// 이미지 업로드 버튼 스타일
export const imageUploadButtonStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: 0,
  right: 0,
  backgroundColor: 'white',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
};

// 텍스트 필드 스타일
export const textFieldStyle: React.CSSProperties = {
  borderRadius: 8,
};

// 버튼 스타일
export const buttonStyle: React.CSSProperties = {
  borderRadius: 8,
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
};

// 페이지 컨테이너 스타일
export const pageContainerStyle: React.CSSProperties = {
  backgroundColor: 'var(--Color-background-main, #f4f6fa)',
  minHeight: '100vh',
};

// 페이지 헤더 스타일
export const pageHeaderStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: 32,
  gap: 16,
};

// 페이지 타이틀 스타일
export const pageTitleStyle: React.CSSProperties = {
  fontWeight: 700,
  color: 'var(--Color-fill-brand-color, #FF6F0F)',
  marginBottom: 8,
};

// 컨텐츠 레이아웃 스타일
export const contentLayoutStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
};

// 반응형 그리드 스타일 (columns는 사용처에서 flex 계산에 활용)
export const responsiveGridStyle = (columns: number): React.CSSProperties => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 32,
});

// 코드 스타일
export const codeStyle: React.CSSProperties = {
  fontFamily: 'monospace',
  fontSize: '0.875rem',
  lineHeight: 1.5,
};

// 코드 배경 스타일
export const codeBackgroundStyle: React.CSSProperties = {
  backgroundColor: 'var(--Color-fill-hover, #F5F5F5)',
  padding: 8,
  borderRadius: 4,
};

// 코드 타이틀 스타일
export const codeTitleStyle: React.CSSProperties = {
  fontWeight: 700,
  color: 'var(--Color-fill-brand-color, #FF6F0F)',
  marginBottom: 8,
};

// 설명 페이퍼 스타일
export const explainPaperStyle: React.CSSProperties = {
  padding: 16,
  borderRadius: 8,
  backgroundColor: 'rgba(255, 220, 175, 0.8)',
  marginBottom: 16,
};

// 설명 타이틀 스타일
export const explainPaperTitleStyle: React.CSSProperties = {
  fontWeight: 700,
  color: 'var(--Color-text-strong, #0D0D0D)',
  marginBottom: 8,
};

// 설명 텍스트 스타일
export const explainPaperTextStyle: React.CSSProperties = {
  color: 'var(--Color-text-normal, #161616)',
  marginBottom: 16,
};

// 설명 이미지 스타일
export const explainImageStyle: React.CSSProperties = {
  width: '100%',
  height: 'auto',
  marginBottom: 16,
};

// 설명 목록 스타일
export const explainListStyle: React.CSSProperties = {
  listStyleType: 'disc',
  paddingLeft: 24,
  marginBottom: 16,
};

// 설명 목록 아이템 스타일
export const explainListItemStyle: React.CSSProperties = {
  marginBottom: 8,
};

// 설명 목록 아이템 텍스트 스타일
export const explainListItemTextStyle: React.CSSProperties = {
  color: 'var(--Color-text-normal, #161616)',
  marginBottom: 8,
};

// 설명 예시 페이퍼 스타일
export const explainExamplePaperStyle: React.CSSProperties = {
  padding: 16,
  borderRadius: 8,
  backgroundColor: 'var(--Color-fill-hover, #F5F5F5)',
  marginBottom: 16,
};

// 설명 예시 타이틀 스타일
export const explainExampleTitleStyle: React.CSSProperties = {
  fontWeight: 700,
  color: 'var(--Color-fill-brand-color, #FF6F0F)',
  marginBottom: 8,
};

// 설명 예시 텍스트 스타일
export const explainExampleTextStyle: React.CSSProperties = {
  color: 'var(--Color-text-normal, #161616)',
  marginBottom: 16,
};

export const explainExampleImageBoxStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginBottom: 16,
};

// 설명 예시 이미지 스타일
export const explainExampleImageStyle: React.CSSProperties = {
  width: '100%',
  height: 'auto',
  marginBottom: 16,
};

// 설명 예시 목록 스타일
export const explainExampleListStyle: React.CSSProperties = {
  listStyleType: 'disc',
  paddingLeft: 24,
  marginBottom: 16,
};

// 설명 예시 목록 아이템 스타일
export const explainExampleListItemStyle: React.CSSProperties = {
  marginBottom: 8,
};

// 설명 예시 목록 아이템 텍스트 스타일
export const explainExampleListItemTextStyle: React.CSSProperties = {
  color: 'var(--Color-text-normal, #161616)',
  marginBottom: 8,
};
